import React, { useState } from "react";
import { FormGroup, Input, Label } from "reactstrap";

import "./PaymentData.scss";

const PaymentData = (props) => {
  const [payment, setPayment] = useState({
    selectedPaymentMethod: "",
  });

  // Payment methods - hardcoded for now
  const loading = false;
  const methods = {
    paymentGateways: {
      nodes: [
        { id: "txpg", title: "Paguaj me kartë (ProCredit)", description: "Paguaj me kartë krediti/debiti përmes ProCredit Bank." },
        { id: "cod", title: "Cash on delivery", description: "Pay with cash upon delivery." },
      ],
    },
  };

  if (loading) {
    return <div className="Payment--loading">{/*Duke u ngarkuar*/}</div>;
  }

  const handleChange = (itemId) => {
    setPayment({
      ...payment,
      selectedPaymentMethod: itemId,
    });
    props.onChange(itemId);
  };

  const paymentMethods = methods.paymentGateways.nodes;
  return (
    <div className="Checkout">
      <div className="row">
        <div className="col-md-6 m-0">
          <div className="base-info-container d-flex flex-column">
            <div className="payment-title">Mënyra e pagesës</div>
            <div className="row">
              <div className="col col-12">
                {paymentMethods.map((item) => {
                  return (
                    <FormGroup key={item.id} check>
                      <div>
                        <Input
                          className="payment-checkbox"
                          type="radio"
                          id={item.id}
                          name="payment"
                          required
                          label={item.title}
                          onChange={(e) => {
                            handleChange(item.id);
                          }}
                        />
                        <span className="payment-label">{item.title}</span>
                        {item.id === "other_payment" &&
                          payment.selectedPaymentMethod === "other_payment" && (
                            <Input
                              className="payment-checkbox"
                              type="text"
                              id="pos_payment_type"
                              name="pos_payment_type"
                              required
                              placeholder="Shkuani emrin e Bankës *"
                              onChange={(e) => {
                                props.onChangeType(e.target.value);
                              }}
                            />
                          )}
                      </div>
                    </FormGroup>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentData;
